module.exports = __webpack_public_path__ + "img/组 3.c0e48ae0.webp";